module.exports = __webpack_public_path__ + "img/linked_service_management.5eb30d7f.svg";